// NOTE: Not currently in use but didn't want to delete the file so we can revive later
import withEnglishLocale from '../functions/withEnglishLocale';
import DefaultPage from '../components/RHInsuranceWordpressPage';
export var __N_SSG = true;
export default withEnglishLocale(DefaultPage);